<template>
  <v-app>
    <topbar v-if="loggedIn && this.$route.name != '404'"></topbar>
    <navigation v-if="loggedIn && this.$route.name != '404'"></navigation>

    <v-content>
      <router-view/>
    </v-content>
    <chat v-if="loggedIn && this.$route.name != '404'"></chat>
  </v-app>
</template>

<script>
    import axios from 'axios'
    import navigation from "./components/navigation";
    import topbar from "./components/topbar";
    import chat from "./components/chat";
    export default {
        name: 'App',
        components: {
            navigation, topbar ,chat
        },
        data (){
        return {
          dialog: false,
          loggedIn:false
        }
      },
        props: {
            source: String
        },
      mounted() {

        let token = localStorage.getItem('token');
        let url = localStorage.getItem('url');
        let auth_user = localStorage.getItem('auth_user');


        if(token){
            axios({
                method: 'get',
                url: url + '/api/users/byUsername/' + auth_user,
                withCredentials: true,
                headers:{
                    'Authorization': 'Basic ' + token
                },
            }).then(() => {
                this.loggedIn = true;
            })
            .catch(() =>{
                localStorage.clear();
                this.loggedIn = false;
                this.$router.push('/login');
            });
        }else{
            this.loggedIn = false;
            this.$router.push('/login');
        }
      },

      created () {

        Event.$on('login',() => {
          this.loggedIn = true;
        });

        Event.$on('logout',() => {
          this.loggedIn = false;
        });
      },

    }
</script>
<style>
  .field-block{
    position: relative;
  }
  .max-length-block{
    right: 0;
    position: absolute;
    font-size: 12px;
    color: red;
  }
.step-bottom-block{
  padding-right: 80px!important;
}
.fa-exclamation-triangle,.max-length-block{
  color: #cc1b1b!important;
}
table td, table th{
  padding: 0 6px!important;
}
  .actions-block{
    border-left: 1px solid #ccc;
  }
  .action-buttons .flex{
    width:44px;
  }
  .action-buttons .v-tooltip {
    display: inherit!important;
  }
  .action-buttons .v-btn {
    margin: 6px 4px!important;
  }
  .disabled-filed .theme--light.v-input:not(.v-input--is-disabled) input, .disabled-filed .theme--light.v-input:not(.v-input--is-disabled) textarea{
    color: rgba(0,0,0,.38)!important;
    cursor: default!important;
  }
  .disabled-filed .theme--light.v-text-field>.v-input__control>.v-input__slot:before{
    border-image: repeating-linear-gradient(90deg,rgba(0,0,0,.38) 0,rgba(0,0,0,.38) 2px,transparent 0,transparent 4px) 1 repeat;
  }
  .disabled-filed .empty-filed .v-label--active{
    max-width: unset!important;
    transform: unset!important;
  }
  .disabled-filed .v-text-field>.v-input__control>.v-input__slot:after {
    border-color: unset;
    border-style: unset;
    border-width: thin 0;
    -webkit-transform: scaleX(0);
    transform: unset;
  }
  .disabled-filed .theme--light.v-label {
    color: rgba(0,0,0,.38)!important;
  }
   .file-info{
     display: inline-flex;
     width: 22px;
     height: 22px;
     background: #eceff1;
     border: 1px solid #fff;
     border-radius: 14px;
     margin-left: 5px;
     justify-content: center;
   }
  .file-info:hover{
    background: #c4c5c5;
  }
  .filed-title {
    height: 20px;
    line-height: 20px;
    color: rgba(0,0,0,.54);
    margin-bottom: 0;
    font-size: 12px;
  }
  .filed-block{
    height: 32px;
    font-size: 16px;
    border-bottom: 1px dotted rgba(0,0,0,.42);
    overflow:auto;
    margin-bottom: 10px;
  }
  .filed-block-area{
    height: 64px;
    font-size: 16px;
    border-bottom: 1px dotted rgba(0,0,0,.42);
    overflow:auto;
    margin-bottom: 10px;
  }
  .link-class:hover{
    background: rgba(0,0,0,.04);
    cursor: pointer;
  }
  table td,table th {
    padding: 0 12px!important;
  }
  .error-file{
    color:red;
    margin: 5px 0;
  }
</style>
